import Splide from '@splidejs/splide';

class Slider {
  constructor(element) {
    this.blockElement = element;
    this.splideElement = this.blockElement.querySelector('.splide');
  }

  init() {
    if (!this.splideElement) {
      return;
    }

    const options = JSON.parse(
      this.splideElement.dataset.splideOptions || '{}'
    );

    const splide = new Splide(this.splideElement, options);

    splide.mount();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider-block').forEach((blockElement) => {
    const instance = new Slider(blockElement);
    instance.init();
  });
});

// Gutenberg / ACF – po załadowaniu lub dodaniu bloku
if (typeof acf !== 'undefined') {
  acf.addAction('ready', (el) => {
    document.querySelectorAll('.slider-block').forEach((blockElement) => {
      const instance = new Slider(blockElement);

      setInterval(instance.init(), 1000);
    });
  });

  acf.addAction('append', (el) => {
    document.querySelectorAll('.slider-block').forEach((blockElement) => {
      const instance = new Slider(blockElement);

      setInterval(instance.init(), 1000);
    });
  });
}
